

<h1 class="page-header">NordNative FAQs</h1>

<div class="container">
  @for (faq of faqs; track faq) {
    <div class="faq" [class.open]="faq.isOpen">
      <div class="faq-summary" (click)="toggleFaq(faq)">
        {{ faq.question }}
      </div>
      @if (faq.isOpen) {
        <div class="faq-content">
          <p [innerHTML]="faq.answer"></p>
        </div>
      }
    </div>
  }
</div>

<div class="col-xs-12" style="height:50px;"></div>
